module.exports = __webpack_public_path__ + "static/media/loginBackground.150b3ee5.svg";